import { render, staticRenderFns } from "./despatch-order-v2.vue?vue&type=template&id=18d606f7&"
import script from "./despatch-order-v2.vue?vue&type=script&lang=js&"
export * from "./despatch-order-v2.vue?vue&type=script&lang=js&"
import style0 from "./despatch-order-v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports